exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".Logo__svg--37Jn7_0{display:block;width:100%}.Logo__footer--3Oe5X_0,.Logo__type--1xaQR_0{fill:#fbfffa}.Logo__testimonial--1KLZz_0 .Logo__footer--3Oe5X_0{fill:#4d8534}.Logo__border--aG6ca_0{fill:#eaeaea}.Logo__mark--2Udq0_0{fill:#f47a3f}", "", {"version":3,"sources":["/Users/tylerjohnson/Sites/Buntin/ServProPrep/src/components/Logo.vue"],"names":[],"mappings":"AACA,oBAAK,cAAc,UAAU,CAC5B,AAGD,4CAAQ,YAAY,CACnB,AACD,mDAAqB,YAAY,CAChC,AACD,uBAAQ,YAAY,CACnB,AACD,qBAAM,YAAY,CACjB","file":"Logo.vue","sourcesContent":["\n.svg{display:block;width:100%\n}\n.type{fill:#fbfffa\n}\n.footer{fill:#fbfffa\n}\n.testimonial .footer{fill:#4d8534\n}\n.border{fill:#eaeaea\n}\n.mark{fill:#f47a3f\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"svg": "Logo__svg--37Jn7_0",
	"type": "Logo__type--1xaQR_0",
	"footer": "Logo__footer--3Oe5X_0",
	"testimonial": "Logo__testimonial--1KLZz_0",
	"border": "Logo__border--aG6ca_0",
	"mark": "Logo__mark--2Udq0_0"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true,"localIdentName":"[name]__[local]--[hash:base64:5]_0","importLoaders":true,"camelCase":true,"modules":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2e098784","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Logo.vue
// module id = KtIG
// module chunks = 1